/**
 * 路由离开前处理（全站 router 调用）。
 * 列表页由 BusinessModuleRouter 内 keep-alive 缓存；离开路由时关闭抽屉/弹层。
 */

export function isSameParentModule(to, from) {
  if (!to || !from || !to.matched.length || !from.matched.length) return false;
  if (to.matched.length < 2 || from.matched.length < 2) return false;
  const fromParent = from.matched[from.matched.length - 2];
  const toParent = to.matched[to.matched.length - 2];
  return !!(fromParent && toParent && fromParent === toParent);
}

export function setRouteLeavingVisual(active) {
  document.querySelectorAll(".page-container").forEach((el) => {
    if (active) {
      el.classList.add("page-route-leaving");
    } else {
      el.classList.remove("page-route-leaving");
    }
  });
}

export function prepRouteLeave(from) {
  if (!from || !from.matched || !from.matched.length) return;

  from.matched.forEach((record) => {
    const vm = record.instances && record.instances.default;
    if (!vm) return;

    if (vm.loading === true) {
      vm.loading = false;
    }
    if (vm.infoDrawerVisible === true) {
      vm.infoDrawerVisible = false;
    }
    if (vm.formRecycleDialogVisible === true) {
      vm.formRecycleDialogVisible = false;
    }
  });
}

export function shouldSkipLeaveDelay(to, from) {
  if (to.meta && to.meta.operate) return true;
  if (isSameParentModule(to, from)) return true;
  return false;
}
